import axios from 'axios';
import { ErrorMsg } from './error';

// get请求
export function get(url: string, params?: any) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params: params })
      .then((res: any) => {
        resolve(res.data);
      })
      .catch(() => {
        reject(ErrorMsg.REQERR);
      });
  });
}

// post请求
export function post(url: string, params?: any) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((res: any) => {
        resolve(res.data);
      })
      .catch(() => {
        reject(ErrorMsg.REQERR);
      });
  });
}
